import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Header from "../../../components/Header";
import { axiosRequest } from "../../../_config/apiClient";
import { showError } from "../../../_config/toastUtil";
import { ToastContainer } from "react-toastify";

const TestInstructions = () => {
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const examConfig = JSON.parse(sessionStorage.getItem("examConfig")) || {};
  const testTitle = examConfig?.testName;

  const startExamAttempt = async () => {
    try {
      let payload = {
        targetType: examConfig.sourceType,
        targetId: examConfig._id,
      }
      const res = await axiosRequest(
        "post",
        "/user/startExamAttempt",
        payload,
        {
          Authorization: `Bearer ${localStorage.getItem("user")}`,
        },
      );

      if (res.error) {
        showError(res.message || "Faild to start exam");
      }

      navigate("/test-interface", {
        state: {
          ...payload,
          sessionId: res.data?._id,
        },
      });
    } catch (error) {
      console.error("Start exam error", error);
      showError("Unable to start exam. Please try again.");
    }
  };

  const guidelinesHtml = examConfig?.guildelines || "";
  console.log("fonfig:: ", examConfig)

  return (
    <div className="flex flex-col h-screen bg-[#F5F7FA] font-sans text-[#333]">
      <ToastContainer />
      <Header testTitle={testTitle} />
      <div className="flex-1 overflow-y-auto">
        <div className="w-full max-w-[1400px] mx-auto px-6 py-10 mt-10">
          <h1 className="text-[24px] md:text-[28px] font-[500] text-center text-[#333333] mb-10 tracking-tight">
            {testTitle || "Test"} - Instructions
          </h1>
          <div className="space-y-6 text-[16px] md:text-[18px] leading-tight text-[#333333] tracking-tight">
            <p className="font-[500]">
              Duration: {examConfig?.durationMinutes || 60} Mins
            </p>
            <p className="font-[500] text-[16px] md:text-[18px] text-[#333333] tracking-tight">
              Read The Following instruction Carefully.
            </p>
            {guidelinesHtml ? (
              <div
                className="max-w-none text-[15px] md:text-[17px] text-[#333333]"
                dangerouslySetInnerHTML={{ __html: guidelinesHtml }}
              />
            ) : (
              <p className="text-red-500 font-[500]">
                Instructions not provided for this test.
              </p>
            )}
            {/* <p className="mt-4 mb-1 font-[500] text-[16px] md:text-[18px] text-[#333333] tracking-tight leading-tight font-inter">
              Language: English
            </p> */}
            {/* <p className="text-[#E63946] text-[16px] font-[500]">
              Please note all questions will appear in your default language.
              This language can be changed for a particular question later on.
            </p> */}
          </div>
        </div>
      </div>
      <footer className="bg-white sticky bottom-0 z-20 w-full">
        <div className="max-w-[1400px] mx-auto px-6 pt-4 pb-2">
          <p className="font-[500] text-[16px] md:text-[18px] text-[#333333] tracking-tight  font-inter mb-2">
            Declaration:
          </p>
          <label className="flex items-start gap-3 cursor-pointer group">
            <div className="relative flex items-center mt-1">
              <input
                type="checkbox"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
                className="peer h-5 w-5 cursor-pointer appearance-none rounded-[2px] border-1 border-[#000000] checked:border-blue-500 checked:bg-blue-500 transition-all"
              />
              <svg
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 h-3.5 pointer-events-none opacity-0 peer-checked:opacity-100 text-white"
                viewBox="0 0 14 10"
                fill="none"
              >
                <path
                  d="M1 5L4.5 8.5L13 1"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span className="font-[500] text-[14px] md:text-[16px] text-[#333333] tracking-tight  font-inter leading-tight select-none">
              I have read all the instructions carefully and have understood
              them. I agree not to cheat or use unfair means in this
              examination. I understand that using unfair means of my own or
              someone else's advantage will lead to my immediate
              disqualification. The decision of BaapBola.com will be final in
              these matters and cannot be appealed.
            </span>
          </label>
        </div>
        <div className="h-[86px]  bg-white sticky bottom-0 z-10 w-full shadow-[0_-2px_4px_rgba(0,0,0,0.25)]">
          <div className="w-full max-w-[1400px] mx-auto px-4 lg:px-6 h-full flex items-center justify-between">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center cursor-pointer gap-2 text-[#333333] font-[500] text-[22px] transition-colors"
            >
              <FiArrowLeft size={22} className="font-[500]" />
              Go to Tests
            </button>

            <button
              onClick={() => {
                if (isChecked) {
                  startExamAttempt();
                } else {
                  alert("Please accept the declaration first.");
                }
              }}
              className={`
                    px-10 py-[7px] rounded-[3px] font-[500] text-[22px] shadow-sm transition-all
                    ${isChecked
                  ? "bg-[#3B82F6] hover:bg-[#2563EB] text-white cursor-pointer"
                  : "bg-gray-300 text-gray-500 cursor-not-allowed"
                }
                `}
            >
              Next
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default TestInstructions;
